module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/img_lp-data__box-img03-831c88166e2321fd79d71fe0c4708e8a.png";